import portosMetadata from './data/metadata.json';
import type { PortosDataVersion } from './types.js';

export const PORTOS_DATA_VERSION: PortosDataVersion = portosMetadata as PortosDataVersion;
